import moment, { MomentInput } from 'moment'

/** User-facing format for full numeric dates (MM-DD-YYYY, leading zeros). */
export const NUMERIC_DISPLAY_DATE_FORMAT = 'MM-DD-YYYY'

/** e.g. "May 26, 2026" — already human-readable; do not reformat. */
const MONTH_NAME_DATE_PATTERN = /^[A-Za-z]{3,9}\s+\d{1,2},?\s+\d{4}$/

/**
 * Formats API / Date values as MM-DD-YYYY for display.
 * Leaves month-name strings unchanged. Returns empty string for null/invalid input.
 */
export function formatNumericDisplayDate(value: MomentInput | null | undefined): string {
  if (value == null || value === '') {
    return ''
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (MONTH_NAME_DATE_PATTERN.test(trimmed)) {
      return trimmed
    }
  }

  const parsed = moment.utc(value)
  if (!parsed.isValid()) {
    return typeof value === 'string' ? value : ''
  }

  return parsed.format(NUMERIC_DISPLAY_DATE_FORMAT)
}
